import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class B2bB2cService {
  // ✅ Default user type is B2C
  private userTypeSubject = new BehaviorSubject<string>('B2C');
  public userType$ = this.userTypeSubject.asObservable();
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const savedType = localStorage.getItem('userType');

      // ✅ Always default to B2C if nothing saved or invalid value found
      if (savedType === 'B2B' || savedType === 'B2C') {
        this.setUserType(savedType as 'B2B' | 'B2C');
      } else {
        this.setUserType('B2C');
      }
    }
  }

  // ✅ Update user type in memory + localStorage
  setUserType(userType: 'B2B' | 'B2C'): void {
    this.userTypeSubject.next(userType);

    if (this.isBrowser) {
      localStorage.setItem('userType', userType);

      // Notify other components (listeners)
      window.dispatchEvent(
        new CustomEvent('userTypeChanged', {
          detail: userType,
        }),
      );
    }
  }

  // ✅ Get current user type
  getCurrentUserType(): string {
    return this.userTypeSubject.value;
  }

  // ✅ Helper methods
  isB2B(): boolean {
    return this.getCurrentUserType() === 'B2B';
  }

  isB2C(): boolean {
    return this.getCurrentUserType() === 'B2C';
  }
}
